module.exports = __webpack_public_path__ + "assets/calendar.1f7fb043.svg";